import React, { Component } from "react";
import { loginAuthProvider } from "../LoginAuthProvider";
import Axios from "axios";
import { API_ROUTE, Routes } from "../Helpers/Constants";
import { Button } from "reactstrap";
import AuthenticationContext from "../Store/Authentication-Context";
import { Spinner } from 'react-bootstrap';
import { setItem } from "./IndexedDBUtils";
export class RegCheck extends Component {
    static contextType = AuthenticationContext;
    constructor(props) {
        super(props);
        this.state = {
            autoLogin: props.autoLogin,
            checked: false,
            isRegistered: false,
            connectionError: false,
            errorMessage: "",
            processLoginErrorMessage: "",
            loggingOff: false,
            loginInProgress:false
        };
        this.regCheck = this.regCheck.bind(this);
        this.loginContinue = this.loginContinue.bind(this);
        this.logout = this.logout.bind(this);
    }

    componentDidMount() {
        this.regCheck();
      
    }
    async processLogin() {
        let photo = null;
        try {
            var token = await loginAuthProvider.getAccessToken();
            var tokenString = token.accessToken;
            var accountInfo = loginAuthProvider.getAccountInfo();
            var email = accountInfo.account.userName;
            const config = {
                headers: { Authorisation: `Bearer ` + tokenString },
            };
            const inputData = {
               Url: window.location.origin,
                ServerPath: "",
                ApiVersion: process.env.REACT_APP_AZURE_CLIENT_ID,
                EmailAddress: email,
                Domain:window.location.hostname

            };

            const response = await Axios.post(API_ROUTE + Routes.GET_PROCESS_LOGIN, inputData, config);
            if (response && response.data)
            {
                if (response.data.errorMessage) {
                    this.setState(prevState => ({
                        processLoginErrorMessage: response.data.errorMessage,
                        loginInProgress: false
                    }));
                    return;
                }
                if (!response.data.redirectUrl) {
                    this.setState(prevState => ({
                        processLoginErrorMessage: "Something went wrong logging you in, please try again.",
                        loginInProgress: false
                    }));
                    console.log("processLogin: missing redirectUrl in response", response.data);
                    return;
                }
                 await this.tawkChat(response.data.loginOrgID);
                //setcontextdata
                sessionStorage.setItem('DomainId', response.data.domainId);
                sessionStorage.setItem('ResellerRole', response.data.resellerRole);
                sessionStorage.setItem('UserType', response.data.userType);
                sessionStorage.setItem('ServerPath', response.data.serverPath);
                sessionStorage.setItem('UserName', response.data.userName);
                sessionStorage.setItem('ResellerID', response.data.resellerID);
                sessionStorage.setItem('orgId', response.data.loginOrgID);
                sessionStorage.setItem('orgName', response.data.loginOrgName);
                sessionStorage.setItem('ManageOrgId', response.data.navigationOrgId);
                sessionStorage.setItem('ManageOrgName', response.data.navigationOrgName);
                sessionStorage.setItem('IsAdministrator', response.data.isAdministrator);
                sessionStorage.setItem('AppID', response.data.appID);
                //localStorage.setItem('parentID', response.data.result.parentID);
                //localStorage.setItem('Url', response.data.result.url);
                sessionStorage.setItem('TenantName', response.data.tenantName);
                sessionStorage.setItem('ManageTenantDomain', response.data.tenantName);
                photo = response.data.photo;
                sessionStorage.setItem('UserDisplayName', response.data.userDisplayName);
                sessionStorage.setItem('UserEmailID', response.data.userEmailID);
                //localStorage.setItem('DisabledAccess', response.data.result.disabledAccess);
                sessionStorage.setItem('IsVeeam365Admin', response.data.isVeeam365Admin);
                sessionStorage.setItem('IsVeeam365Engineer', response.data.isVeeam365Engineer);
                sessionStorage.setItem('IsVeeam365JobManagement', response.data.isVeeam365JobManagement);
                sessionStorage.setItem('IsVeeam365Restore', response.data.isVeeam365Restore);
                sessionStorage.setItem('IsVeeam365AdminSales', response.data.isVeeam365AdminSales);
                sessionStorage.setItem('ServiceProvider', response.data.serviceProvider);
                sessionStorage.setItem('CloudCoverToken', response.data.cloudCoverToken);
                ////sessionStorage.setItem('ManageTenantDomain', response.data.domainId);
                if (response.data.m365Enabled) {
                    sessionStorage.setItem('GuardianOnlyEnabled-' + response.data.loginOrgID, !(response.data.m365Enabled.toString() === "true"));
                }
                const isAdmin = JSON.parse(sessionStorage.getItem('IsAdministrator'));
                if (!isAdmin) {
                    if (response.data.redirectUrl.includes("Restore"))
                    {
                        sessionStorage.setItem('IsEndUser', true);
                    }
                }
                if (photo) {
                    await setItem('Photo', photo);
                }
                window.location.href = response.data.redirectUrl;
                return;
            }
        }
        catch(reason) {
            this.setState(prevState => ({
                loginInProgress: false,
                processLoginErrorMessage: "Something went wrong logging you in, please try again."
            }));
            console.log("catch Notification: " + reason);
        }
    }
    async tawkChat(orgId) {
        try {
            const config = {
                headers: {
                    Authorisation: "Bearer NOT REQUIRED`",
                },
            };
        
            const inputData = {
                OrgId: orgId,
                data: "TawkChat",
            };
            if ( orgId != null) {
                const response = await Axios.get(API_ROUTE + Routes.GET_TAWKCHAT(orgId), config);
                const data = response.data;
                if (data === "True") {
                    sessionStorage.setItem('TawkChat', JSON.stringify({
                        OrgId: orgId,
                        TawkChat: true
                    }));

                }
                else {
                    sessionStorage.setItem('TawkChat', JSON.stringify({
                        OrgId: orgId,
                        TawkChat: false
                    }));
                }
            }
        } catch (error) {
        }
    }

    async regCheck() {
        const { setAuthContext } = this.context;
        var tokenString = await setAuthContext(new Date());
        const config = {
            headers: { Authorisation: `Bearer ` + tokenString },
        };
        Axios.get(API_ROUTE + Routes.REG_CHECK, config)
            .then((response) => {
                let responseData = response.data;
                if (responseData.connectionError) {
                    this.setState({
                        checked: true,
                        isRegistered: false,
                        connectionError: true,
                        errorMessage: responseData.errorMessage
                    });
                } else if (!responseData.registered) {
                    this.setState({
                        checked: true,
                        isRegistered: false,
                        connectionError: false,
                        errorMessage: responseData.errorMessage
                    });
                } else {
                    this.setState(
                        {
                            checked: true,
                            isRegistered: responseData.registered
                        }, () => {
                            if (this.state.autoLogin && responseData.registered && this.state.loggingOff ===false) {
                                this.loginContinue();
                            }
                        });
                }

            })
            .catch((reason) => {

            });
    }

    async loginContinue() {

        await this.props.login();
        this.setState(prevState => ({
            loginInProgress: true
        }));
        try {
            await this.processLogin();
        } catch (reason) {
            this.setState(prevState => ({
                loginInProgress: false,
                processLoginErrorMessage: "Something went wrong logging you in, please try again."
            }));
            console.log("loginContinue catch: " + reason);
        }
    }

    register(event) {
        event.preventDefault();
        var redirectString = "/SignUp";
        window.location = redirectString;
    }

    logout(event) {
        event.preventDefault();
        this.setState(prevState => ({
            ...prevState,
            loggingOff: true
        }));
        loginAuthProvider.logout();
    }

    render() {
        if (!this.state.checked) {
            return (
                <React.Fragment>
                    <p style={{ fontWeight: '500', fontFamily: "'Poppins', sans-serif" }}>
                        Getting registration status.
                    </p>
                </React.Fragment>
            );
        } else {
            
            if (this.state.isRegistered && this.state.processLoginErrorMessage === "") {
                var accountInfo = loginAuthProvider.getAccountInfo();
                var email = accountInfo.account.userName;
                var name = accountInfo.account.name;
                return (
                    <React.Fragment>
                        <p style={{ fontWeight: '500', fontFamily: "'Poppins', sans-serif" }}>
                            You are logged in as {name} ({email}).
                        </p>
                        <p style={{ fontWeight: '500', fontFamily: "'Poppins', sans-serif" }}>Use these credentials to login to CloudCover 365?</p>
                        <div>
                            {this.state.loginInProgress
                                ?
                                <Button color="primary" onClick={this.loginContinue} style={{ padding: '4px 33px', fontWeight: 'bold', fontSize: '13px' }}><Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /></Button>
                                :
                                <Button color="primary" onClick={this.loginContinue} style={{ padding: '4px 26px', fontWeight: 'bold', fontSize: '13px', marginRight: "5px" }}>Log In</Button>}
                            
                            <Button color="primary" onClick={this.logout} style={{ padding: '4px 20px', fontWeight: 'bold', fontSize: '13px', marginLeft: "5px" }}>Log Out</Button>
                        </div>
                    </React.Fragment>
                );
            } else {
               

                if (this.state.processLoginErrorMessage !== "" && this.state.processLoginErrorMessage.includes('Your organisation does not appear to have an account')) {
                    return (
                        <React.Fragment>
                            <p>
                                It appears you aren't registered.
                            </p>
                            <div>
                                <Button color="primary" onClick={this.register} style={{ marginRight: "5px" }}>Register</Button>
                                <Button color="primary" onClick={this.logout} style={{ marginLeft: "5px" }}>LogOut</Button>
                            </div>
                        </React.Fragment>
                    );
                } 
                if (this.state.processLoginErrorMessage !== "") {
                    return (
                        <React.Fragment>
                            <p style={{ color: "red", fontSize: "small" }}>
                                {this.state.processLoginErrorMessage}
                            </p>
                            <div>
                                <Button color="primary" onClick={this.logout}>Log Out</Button>
                            </div>
                        </React.Fragment>
                    );
                } 

                if (this.state.connectionError) {
                    return (
                        <React.Fragment>
                            <p>
                                Service unavailable, please try later.
                            </p>
                            <div>
                                <Button color="primary" onClick={this.logout}>Log Out</Button>
                            </div>
                        </React.Fragment>
                    );
                } else {
                    if (this.state.errorMessage !== "" && this.state.errorMessage !== null) {
                        return (
                            <React.Fragment>
                                <p style={{ color: "red", fontSize: "small" }}>
                                    {this.state.errorMessage}
                                </p>

                            </React.Fragment>
                        );
                    } else {
                        return (
                            <React.Fragment>
                                <p>
                                    It appears you aren't registered.
                                </p>
                                <div>
                                    <Button color="primary" onClick={this.register} style={{ marginRight: "5px" }}>Register</Button>
                                    <Button color="primary" onClick={this.logout} style={{ marginLeft: "5px" }}>Log Out</Button>
                                </div>
                            </React.Fragment>
                        );
                    }
                }
            }
        }
    }
}
